import { useEffect } from 'react';
import docs from '~/assets/icons/docs.svg';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { SectionHeading } from '~/components/ui/SectionHeading';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { useStartExam } from '../../hooks';
import {
	setExams,
	setSelectedIndex,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { Category, licenseIcons } from '../Category';
import {
	StyledCategoriesContainer,
	StyledContainer,
	StyledDescriptionBackground,
	StyledDescriptionContainer,
} from './Main.styled';

const Main: React.FC = () => {
	const dispatch = useLayoutDispatch();
	const { handleStartExam } = useStartExam();
	const selectedIndex = useLayoutSelector(
		(state) => state.drivingSchool.selectedIndex,
	);

	const examList = useObservable(rage.drivingSchool.getExams());

	useEffect(() => {
		dispatch(setExams(examList));
	}, [examList]);

	return (
		<StyledContainer>
			<SectionHeading icon={docs} text="Выберите категорию" gap={20} />
			<StyledCategoriesContainer>
				{examList.map((item, index) => (
					<Category
						type={item.letter}
						name={item.name}
						price={item.price}
						icon={licenseIcons[item.id]}
						selected={index + 1 === selectedIndex}
						onClick={() => dispatch(setSelectedIndex(index + 1))}
						notActive={item.isOwned}
						key={index}
					/>
				))}
			</StyledCategoriesContainer>
			<StyledDescriptionContainer>
				<StyledDescriptionBackground />
				<Text>
					Добро пожаловать в Лицензионный центр Сан Андреса!
					<br />
					<br />
					После того как вы выберите нужную категорию, вам нужно будет сдать
					практический тест на владение тем или иным видом транспортного
					средства, пройдя заранее заданный маршрут.
				</Text>
			</StyledDescriptionContainer>
			<Button
				height={ButtonHeight.Height60}
				color={ButtonColors.Select2}
				disabled={selectedIndex === 0}
				onClick={handleStartExam}
				style={{
					marginTop: '60px',
					width: 'fit-content',
				}}
			>
				<Text>
					{selectedIndex === 0 ? 'Выберите категорию' : 'Начать экзамен'}
				</Text>
			</Button>
		</StyledContainer>
	);
};

export { Main };
